import React, {useContext} from 'react'
import './style.scss'
import ApolloContext from '../../../../../context/ApolloContext'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import Loading from '../../../../../apollo/Loading'

function CustomBlock({images: img, files: file, fields: field, wysiwygs: wysiwyg, maps: map}) {
    const apollo = useContext(ApolloContext)

    const posts = apollo.data?.studentStories.nodes.map((node, i) => { 
 
        return (
            <article className="single-post span-12 grid-12" key={i}>
                 <div className="img-container span-5">
                    <div className="img-wrapper">
                        <Link to={node.uri} title={node.title}>
                            <img srcSet={node.featuredImage.node.srcSet} alt=''/>
                        </Link>
                    </div>
                </div>
                <div className="box span-7">
                    <h3>
                        <Link to={node.uri}>
                            {node.title}
                        </Link>
                    </h3>
                    <div className="excerpt" dangerouslySetInnerHTML={{__html: node.excerpt}}/>
                </div>
            </article>
        )
    })
    

	return (
        <div className="grid-12 ">
            <>

                <div className="span-6 span-12-tablet animated delay-2 grid-12" style={{paddingLeft: '2rem'}}>

                {apollo.isLoading ? 
                  <div className="span-12 loading">
                    <Loading />
                  </div> 
                : 
                  posts
                }

                </div>
                <div className=" side-img span-6 span-12-tablet">
                    <div className="desc" dangerouslySetInnerHTML={{__html: wysiwyg}}/>
                    <div className="img-wrap animated from-right delay-2">
                        <Img fluid={img}
                        imgStyle={{objectFit: 'cover'}}
                        objectPosition='50% 50%'
                        className="image"
												alt=''
                        />
                    </div>
                </div>
            </>
        </div>
	)
}

export default CustomBlock